module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "c-footer u-fit-w u-bg--black-near"
  }, [_c('div', {
    staticClass: "c-fotter__header u-marg-x-auto u-flex u-flex-ai-center u-flex-jc--center u-w10of12"
  }, [_c('router-link', {
    staticClass: "c-footer__header__link u-relative u-block u-opacity--25",
    attrs: {
      "to": _vm.CONFIG.pages.home.path
    }
  }, [_c('app-icon', {
    staticClass: "u-fit u-fill--white u-stroke--white",
    attrs: {
      "name": "logotype"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "c-footer__footer u-marg-x-auto u-flex u-flex-fd--column@sm u-flex-jc--space-between u-w10of12 u-pad-y-sm"
  }, [_c('div', {
    staticClass: "c-footer__footer__copyright u-w1of2 u-marg-t-xs@sm t-ffamily--simplon t-fsize--xs t-fweight--bold u-uppercase u-color--white u-opacity--25"
  }, [_vm._v("\n            Copyright Practical 2018\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "u-flex u-flex-ai--end u-flex-jc--space-bewteen u-block@xs"
  }, _vm._l((_vm.$root.content.global.header.links), function(item, index) {
    return (item.isVisible) ? _c('router-link', {
      key: index,
      staticClass: "c-footer__footer__link u-marg-t-0@sm t-ffamily--simplon t-fsize--xs t-fweight--bold u-uppercase u-block@xs",
      class: ['c-header__nav__list__item--' + index, _vm.$root.componentId === item.component ? 'is-active' : ''],
      attrs: {
        "to": _vm._getURLFromComponent(item.component),
        "index": index
      }
    }, [_c('div', {
      staticClass: "c-footer__footer__item__text u-relative",
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e694a728"}!./src/scripts/components/app-footer/template.html
// module id = 484
// module chunks = 0